import { addToast } from 'src/toasts'

// F-34. The history tab renders the most recent 100 rows; this fetches the next page.
//
// 🔑 Delegated to #offcanvasRight, which is the persistent container the tab is rendered into — the button
// itself is replaced on every page, so a direct binding would be lost after the first click.
// 📌 The cursor lives on the button as `data-before-id` (the id of the oldest row shown) rather than a page
// number, so a page cannot be skipped or repeated if an audit is written while the tab is open.
// 🚨 **Registered idempotently, because it IS called twice on some pages.** My first version claimed "only
// one of the customers and clients packs runs on a given page" — wrong: `application.js:268` calls
// `clientFunctions()` for **every ADMIN** on every desktop page, while `customers/index.js:13`,
// `quality_controls/index.js:79`, `events/call_list.js:8` and the two dashboard packs call
// `customerFunctions()`. An ADMIN on the customers index therefore ran this twice, registered two delegated
// handlers, and one click fired two `$.getScript` calls with the same cursor — `more.js.erb` appending the
// same 100 rows twice, and every later page too, since the replaced button carries the same `before_id`.
// 📌 `off('click.historyLoadMore')` before `on`, not a module-level `registered` flag: Turbolinks replaces
// the body on every navigation, so `#offcanvasRight` is a new element each time and the handler genuinely
// must be re-registered. A flag would block that and the button would stop working after the first page.
export default () => {
  $('#offcanvasRight').off('click.historyLoadMore').on('click.historyLoadMore', '#history-load-more', function (event) {
    event.preventDefault()

    const button = $(this)
    const url = button.data('url')
    const beforeId = button.data('before-id')
    if (!url || !beforeId) return

    // No fullscreen loader: this appends to a list the user is already reading, so blanking the screen
    // would be worse than the wait. The button's own disabled state is the feedback.
    button.prop('disabled', true)

    $.getScript(`${url}?before_id=${encodeURIComponent(beforeId)}`).fail(() => {
      button.prop('disabled', false)
      addToast(I18n.t('errors.unexpected_error'), 'error')
    })
  })
}
